import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ProfilePhoto.scss';

const DEFAULT_URL = 'https://s3.amazonaws.com/resy.com/images/user.jpg';

const ProfilePhoto = (props) => {
  const {
    url,
    size,
    isGda,
    onClick,
  } = props;

  return (
    <div
      onClick={onClick}
      onKeyDown={onClick}
      role="link"
      className="ProfilePhoto"
      tabIndex={onClick && 0}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <div
        className={cx('ProfilePhoto__image', {
          'ProfilePhoto__image--rga': isGda,
        })}
        style={{
          backgroundImage: `url("${url || DEFAULT_URL}")`,
        }}
      />
      <div
        className={cx('ProfilePhoto__image--border')}
      />
    </div>
  );
};

ProfilePhoto.propTypes = {
  url: PropTypes.string,
  isGda: PropTypes.bool,
  size: PropTypes.string,
  onClick: PropTypes.func,
};

ProfilePhoto.defaultProps = {
  url: DEFAULT_URL,
  isGda: false,
  size: '42',
  onClick: undefined,
};

ProfilePhoto.displayName = 'ProfilePhoto';
export default ProfilePhoto;
